import * as React from 'react';
import { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import { Grid, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';

import valmetLogo from '../assets/valmet_logo@3x.png';
import LoginForm from './LoginForm';
import ChangePasswordForm from './ChangePasswordForm';
import { AuthContext } from '../store/authContext';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginTop: '5rem',
  },
  logo: {
    height: '5rem',
  },
  title: {
    color: theme.palette.secondary.main,
    marginTop: -16,
  },
  form: {
    maxWidth: 438,
  },
}));

const Login: React.FC = () => {
  const { user } = useContext(AuthContext);

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      sx={{   marginTop: '5rem'}}
    >
      <Grid item>
        <img src={valmetLogo} alt="Valmet logo" style={{ height: '5rem'}}
        />
      </Grid>
      <Grid item>
        <Typography sx={(theme) => ({
                      color: theme.palette.secondary.main,
                      marginTop: -16})
                    }>
          Valmet Product Tracker
        </Typography>
      </Grid>
      <Grid item xl={8} md={6} xs={11} sx={{ maxWidth: 438}}>


        {user?.challengeName === 'NEW_PASSWORD_REQUIRED' ? (
          <ChangePasswordForm />
        ) : (
          <LoginForm />
        )}
      </Grid>
    </Grid>
  );
};

export default Login;
